export const notificationsMsgs = {
  DEFAULT_ERROR: "Something went wrong. Please try again.",
  EXPIRE_SESSION: "Your Session is expired, login Please.",
  WRONG_CREDENTIALS: "Your credentials are incorrect.",

  LOGIN: "You logged in successfully.",
  SIGNUP: "Your account created successfully.",
  FORGOT_PASSWORD: "The reset password link has been sent to your email. please check your email.",
  RESET_PASSWORD: "Your Password has been changed successfully.",
  RESND_ACTIVATION_EMAIL: "The activation email has been sent to your email. please check your email.",

  EMAIL_CONFIRMATION: "Your Email has been confirmed successfully.",
  WRONG_URL_ADDRESS: "You are coming from the wrong URL address!",
  DECLINE_RESET_PASSWORD:
    "Don't worry your account is still secure and the password has not been changed.\nThe original reset link has now been terminated and can no longer be accessed.",

  USER_RESET_PASSWORD: "The password reset link was sent to the user's email.",
  USER_ASSIGN_PRODUCT: "Access assigned successfully",
  USER_ROLES_UPDATED: "User's roles updated successfully",

  API_ACCOUNT_ASSIGN_PRODUCT: "Access assigned successfully",
  API_ACCOUNT_KEY_DELETE: "Token successfully deleted",
  API_ACCOUNT_KEY_CREATE: "Token successfully created",
  API_ACCOUNT_KEY_TOKEN_COPY: "Token copied to clipboard",
  API_ACCOUNT_ROLES_UPDATED: "API Account roles updated successfully",

  MERGE_ORGANISATIONS: "Organisations merged successfully",

  UPLOAD_PROFILE_PICTURE: "Your picture uploaded successfully",
  REMOVE_PROFILE_PICTURE: "Your picture removed successfully",
  UPDATE_PROFILE: "Your profile updated successfully",

  ADD_ITEM: (itemName: string) => `${itemName} added successfully`,
  Edit_ITEM: (itemName: string) => `${itemName} edited successfully`,
  DELETE_ITEM: (itemName: string) => `${itemName} removed successfully`,
};
